import React from "react";
import PropTypes from "prop-types";
import { Fragment } from "../../../shared_components/little_router";

import CountrySelect from "../../containers/country_select";
import YearSelect from "../../containers/year_select";
import ActiveLink from "../../../shared_components/active_link";
import LoadingSpinner from "../../../shared_components/loading_spinner";
import CentralBlankTabMessage from "../../../shared_components/central_blank_tab_message";

import GlobalChangeMapChart from "../../containers/visualizations/global_change_map_chart";
import GlobalChangeOverTimeChart from "../../containers/visualizations/global_change_over_time_chart";
import GlobalHistogramChart from "../../containers/visualizations/global_histogram_chart";
import GlobalBreakdownChart from "../../containers/visualizations/global_breakdown_chart";
import GlobalChangeMapTable from "../../containers/visualizations/global_change_map_table";
import GlobalChangeOverTimeTable from "../../containers/visualizations/global_change_over_time_table";
import GlobalHistogramTable from "../../containers/visualizations/global_histogram_table";
import GlobalBreakdownTable from "../../containers/visualizations/global_breakdown_table";


import GlobalVerticalChart from "../../containers/visualizations/global_vertical_chart";
import GlobalCountryInfoPanel from "../../containers/visualizations/global_country_info_panel";
import { makeSlug, makeChildSlug } from "../../routes";
import ResetButton from "../../containers/reset_button";

class GlobalSection extends React.Component {
  render () {
    let tableAndChart;

    if (this.props.countrySelected) {
      tableAndChart = (<div>
        <div className="chart">
          <Fragment forRoute={makeChildSlug("global", "change_map")}>
            <GlobalChangeMapChart />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "change_over_time")}>
            <GlobalChangeOverTimeChart />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "breakdown")}>
            <GlobalBreakdownChart />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "histogram")}>
            <GlobalHistogramChart />
          </Fragment>
        </div>

        <div className="table">
          <Fragment forRoute={makeChildSlug("global", "change_map")}>
            <GlobalChangeMapTable />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "change_over_time")}>
            <GlobalChangeOverTimeTable />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "breakdown")}>
            <GlobalBreakdownTable />
          </Fragment>
          <Fragment forRoute={makeChildSlug("global", "histogram")}>
            <GlobalHistogramTable />
          </Fragment>
        </div>
      </div>);
    } else if (this.props.onMapTab && this.props.hasMainChart) {
      tableAndChart = (<div>
        <div className="chart">
          <GlobalChangeMapChart />
        </div>

        <div className="table" style={{ position: "relative" }}>
          <CentralBlankTabMessage message="Please select a country" doNotPullMessageUp={true} />
        </div>
      </div>);
    } else {
      tableAndChart = <CentralBlankTabMessage message="Please select a country" />;
    }

    return (
      <div className="main">
        <div className="row">
          <div className="filter-area col-md-12">
            <YearSelect />
            <CountrySelect />
            <ResetButton />
          </div>
        </div>

        <div className="row">
          <div className="tabs col-md-2">
            <div className="global info-panel">
              <GlobalCountryInfoPanel />
            </div>
            <nav className="tab-nav">
              <h4>Change main chart</h4>
              <ActiveLink href={makeSlug("global", "change_map")}>
                Map of surveyed countries
              </ActiveLink>
              <ActiveLink href={makeSlug("global", "change_over_time")}>
                Tariffs over time by city
              </ActiveLink>
              <ActiveLink href={makeSlug("global", "breakdown")}>
                Tariff breakdowns by city
              </ActiveLink>
              <ActiveLink href={makeSlug("global", "histogram")}>
                Tariff distribution
              </ActiveLink>
            </nav>
          </div>

          <div className="chart-and-table col-md-6">
            {tableAndChart}

            <LoadingSpinner show={this.props.isLoading}/>
          </div>

          <div className="vertical-chart col-md-4">
            <GlobalVerticalChart />
          </div>

        </div>
      </div>
    );
  }
}

GlobalSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  countrySelected: PropTypes.bool.isRequired,
  onMapTab: PropTypes.bool.isRequired,
  hasMainChart: PropTypes.bool.isRequired
};

export default GlobalSection;
